export const TOP_NAV_DEFAULTS = {
  logout: {
    label: 'Sign Out',
    icon: 'log'
  },
  userSettingsProfileMenuEntry: {
    label: 'Settings',
    icon: 'settings'
  },
  userSettingsDialog: {
    dialogHeader: 'User Settings',
    saveBtn: 'Save',
    dismissBtn: 'Cancel'
  },
  globalSearchSubmitButton: 'Search',
  globalSearchCenteredCancelButton: 'Cancel'
};

export const NAVIGATION_DEFAULTS = {
  externalLink: {
    sameWindow: false
  }
};
